export type BillingBuyerInfo = {
  buyerName: string;
  buyerEmail: string;
  buyerTel: string;
};

const STORAGE_KEY = 'billingBuyerInfo:v1';

const normalizeValue = (value: string | null | undefined) => (value ?? '').trim();

export const isBillingBuyerInfoComplete = (info: BillingBuyerInfo | null | undefined) => {
  if (!info) return false;
  return Boolean(
    normalizeValue(info.buyerName) &&
      normalizeValue(info.buyerEmail) &&
      normalizeValue(info.buyerTel)
  );
};

export const loadBillingBuyerInfo = (): BillingBuyerInfo | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const candidate: BillingBuyerInfo = {
      buyerName: normalizeValue(parsed?.buyerName),
      buyerEmail: normalizeValue(parsed?.buyerEmail),
      buyerTel: normalizeValue(parsed?.buyerTel)
    };
    return isBillingBuyerInfoComplete(candidate) ? candidate : null;
  } catch {
    return null;
  }
};

export const saveBillingBuyerInfo = (info: BillingBuyerInfo) => {
  try {
    const payload = {
      buyerName: normalizeValue(info.buyerName),
      buyerEmail: normalizeValue(info.buyerEmail),
      buyerTel: normalizeValue(info.buyerTel)
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {}
};

export const clearBillingBuyerInfo = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
};
